/**
 * AuthMenu — вход через Google / текущий пользователь + выход (D11).
 * Если есть per-user токен (после Google-входа) — показываем email и «Выйти».
 * Иначе — кнопку «Войти через Google». Пока пользователь не вошёл, UI работает на fallback-токене.
 */
import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { LogIn, LogOut } from 'lucide-react';

import { api } from '../shared/api/client';
import { getUserToken, startGoogleLogin, logout } from '../shared/auth/userToken';

interface Me {
  id?: string;
  email?: string | null;
  name?: string | null;
  authenticated: boolean;
}

export const AuthMenu: FC = () => {
  const hasToken = !!getUserToken();

  const { data: me } = useQuery<Me>({
    queryKey: ['auth-me'],
    queryFn: async () => (await api.get<Me>('/api/auth/me')).data,
    enabled: hasToken,
    retry: 0,
  });

  if (!hasToken) {
    return (
      <button
        type="button"
        onClick={startGoogleLogin}
        className="inline-flex items-center gap-2 rounded-md border border-border bg-card px-3 py-1.5 text-sm hover:bg-accent transition-colors"
      >
        <LogIn className="w-4 h-4" /> Войти через Google
      </button>
    );
  }

  return (
    <div className="inline-flex items-center gap-2">
      <span className="text-sm text-muted-foreground max-w-[180px] truncate">
        {me?.email || me?.name || me?.id || 'Пользователь'}
      </span>
      <button
        type="button"
        onClick={logout}
        className="inline-flex items-center gap-1 rounded-md border border-border px-2 py-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Выйти"
        title="Выйти"
      >
        <LogOut className="w-4 h-4" />
      </button>
    </div>
  );
};
